// extracted by mini-css-extract-plugin
module.exports = {"cardCategory":"styles_cardCategory__v_e4E","withshadow":"styles_withshadow__DEIEM"};